(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-related-articles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.related-articles');
    
    sections.forEach(section => {
      const track = section.querySelector('.related-articles__slider-track');
      const dots = section.querySelectorAll('.related-articles__dot');
      
      if (!track || dots.length === 0) return;
      
      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.index);
          
          // Move the track by 100% of the window width for each page (3 cards)
          track.style.transform = `translateX(-${index * 100}%)`;
          
          // Update dot states
          dots.forEach(d => d.classList.remove('is-active'));
          dot.classList.add('is-active');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-sidebar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sidebarNav = document.querySelector('.article-content-sidebar__nav');
    const sidebarLinks = document.querySelectorAll('.article-content-sidebar__link');
    const summarySection = document.getElementById('blog-summary');
    
    if (!sidebarNav || !summarySection) return;

    // Sections to track for ScrollSpy
    const sectionIds = ['blog-summary', 'faqs-section', 'generated-article-liquid', 'camera-roll', 'products'];
    const sections = sectionIds.map(id => document.getElementById(id)).filter(el => el !== null);

    const updateSidebar = () => {
      const summaryRect = summarySection.getBoundingClientRect();
      
      // 1. Handle Sticky State
      if (summaryRect.top <= 150) { 
        sidebarNav.classList.add('is-sticky');
      } else {
        sidebarNav.classList.remove('is-sticky');
      }

      // 2. Handle Active Link (ScrollSpy)
      let currentSectionId = '';
      const scrollPosition = window.scrollY + 120; // Offset for better detection

      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          currentSectionId = section.id;
        }
      });

      // Special case: if we are at the bottom of the page, the last section might be active even if offset is not met
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 50) {
        currentSectionId = sections[sections.length - 1]?.id || '';
      }

      sidebarLinks.forEach(link => {
        link.classList.remove('is-active');
        if (link.getAttribute('href') === `#${currentSectionId}`) {
          link.classList.add('is-active');
        }
      });
    };

    window.addEventListener('scroll', updateSidebar);
    window.addEventListener('resize', updateSidebar);
    updateSidebar(); // Initial check
  });

  } catch(e) { console.error(e); }
})();
})();
